<template>
  <div class="min-h-screen flex items-center justify-center">
    <div class="text-center px-6">
      <div class="mb-8">
        <h1 class="text-9xl font-bold text-primary">404</h1>
        <p class="text-2xl font-semibold text-base-content mt-4">Page Not Found</p>
        <p class="text-base-content/60 mt-2">
          The page you're looking for doesn't exist or has been moved.
        </p>
      </div>
      
      <div class="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <router-link 
          :to="{ name: 'Dashboard' }" 
          v-if="isAuthenticated"
          class="btn btn-primary text-white dark:text-primary-content"
        >
          Go to Dashboard
        </router-link>
        <router-link 
          :to="{ name: 'Login' }" 
          v-else
          class="btn btn-primary text-white dark:text-primary-content"
        >
          Go to Login
        </router-link>
        <button 
          @click="goBack" 
          class="btn btn-ghost"
        >
          Go Back
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()
const isAuthenticated = authStore.isAuthenticated

const goBack = () => {
  if (window.history.length > 1) {
    router.back()
  } else {
    router.push({ name: isAuthenticated ? 'Dashboard' : 'Login' })
  }
}
</script>